export * as dsEnums from './device-storage/model/enums';
export * as httpEnums from './new-http-data/model/enums';
export * as oofEnums from './oof-db-service/model/enums';
export * as uploadCollectorEnums from './upload-collector/model/enums';
export * as userEnums from './user-account/model/enums';
export * as webEnums from './web-aggregator/model/enums';
